module.exports = __webpack_public_path__ + "static/media/planet.f8f1cb96.png";